import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/accounts/Page";

export const PATH = "/vendors/settings/accounts";

function AccountSetting() {
	return (
		<>
			<NskHead title="アカウント設定" />
			<Component />
		</>
	);
}

export default AccountSetting;
